export default "__VITE_ASSET__eb43c409__"